export default "__VITE_ASSET__af445854__"